export default "__VITE_ASSET__ffbf251b__"